module.exports = __webpack_public_path__ + "static/weronikawork4-758053b134b1e041386b1374c893ef4c.jpg";